import { SessionType, SportType, SessionContents } from '../../enums/index.js';

class MlbSessionConverterer {
    constructor(creatorId, rules, status, leagueId, sessionContents, schemaRef, sensorModel, pitchingMoundDistance) {
        // TODO - type check
        this.template = {
            // @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
            id: null,
            ownerID: creatorId || 0,
            createDate: null,
            modificationDate: null,
            endDate: null,
            processingDate: null,
            sessionTypeID: 6,
            sessionType: SessionType.Game.key,
            status: status|| 'displayBoth',
            gameStatus: 'INITIALIZED',
            displayName: null,
            deviceID: null,
            isOfficial: true,
            leagueID: leagueId || 0,
            dataVerified: true,
            parameters: {
                // @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-parameter-v2.json
                SportType: SportType.Baseball.key,
                GameVisibility: status || 'displayBoth',
                SessionContents: sessionContents || SessionContents.RTS.key,
                SessionSchemaRef: schemaRef || 'http://ws.flightscope.local/schema/baseball/entity/session-v2.json#',
                AppVersion: 'WEB_BaseballStats_2.2.0',
                SensorModel: sensorModel || 0,
                PITCHING_MOUND_DISTANCE: pitchingMoundDistance || 18.44,
            },
            rules: rules || {},
            lineups: [],
            lineupTeamsOrganizationCodes: [],
            results: [],
            resultsCount: 0,
            lineScore: {},
            access: null,
            mediaForSession: [],
            mediaForResult: [],
        };
    }

    convert(game) {
        // TODO - entity
        if (!game || typeof(game) !== 'object') {
            throw new TypeError('game must be an object');
        }

        const session = Object.assign({}, this.template);
        if (game.gamePk) {
            // TODO - maybe some custom id converter ?
            session.id = game.gamePk;
        }
        if (game.gameData) {
            if (game.gameData.datetime) {
                session.createDate = (new Date(game.gameData.datetime.dateTime)).toISOString();
            }

            if (game.gameData.status) {
                session.gameStatus = this.determineGameStatus(game.gameData.status.statusCode);
            }

            if (game.gameData.teams) {
                session.displayName = this.buildDisplayName(
                    game.gameData.teams.away, game.gameData.teams.home, game.gameData.datetime.originalDate
                );
            }
        }

        return session;
    }

    determineGameStatus(statusCode) {
        switch (statusCode) {
            case 'F':
                return 'OFFICIAL';
            // TODO - support more statuses
            default:
                return 'INITIALZIED';
        }
    }

    buildDisplayName(awayTeam, homeTeam, dateTime) {
        if (!awayTeam || !homeTeam) {
            return 'session';
        }

        return `${awayTeam.teamName} vs ${homeTeam.teamName}, ${dateTime}`;
    }
}

export default MlbSessionConverterer;